import React from 'react'
import { BrowserView, MobileView } from 'react-device-detect'
import { Box, Paper, Typography, useTheme } from '@mui/material'

import { ApplicationIcon } from '../../components/Icons/ApplicationIcon'
import { DownloadAppStoreIcon } from '../../components/Icons/DownloadAppStoreIcon'
import { IOS_APP_URL } from '../../components/ApplicationProgress/types'
import { QrCode } from '../../components/Icons/QrCode'

export const DownloadAppComponent: React.FC = () => {
  const theme = useTheme()
  return (
    <Paper
      elevation={2}
      sx={{
        maxWidth: 325,
        minWidth: 200,
        borderRadius: 2.5,
        p: 5,
        backgroundImage: `linear-gradient(to right, ${theme.palette.gradient.main}, ${theme.palette.secondary.main})`
      }}
    >
      <Typography component="div" variant="h5" fontWeight={600} align="center">
        You can earn great rewards with the Paceline app!
      </Typography>

      <Box style={{ textAlign: 'center', marginTop: 20 }}>
        <ApplicationIcon
          sx={{ height: '3.5em', width: '3.5em', borderRadius: 2 }}
        />
      </Box>

      <Box style={{ textAlign: 'center', marginTop: 50 }}>
        <BrowserView>
          <QrCode sx={{ height: '3.5em', width: '3.5em' }} />
          <Typography component="div" variant="caption">
            Scan to download the Paceline app
          </Typography>
        </BrowserView>
        <MobileView>
          <DownloadAppStoreIcon
            sx={{ height: '3.5em', width: '5em' }}
            onClick={() => window.open(IOS_APP_URL)}
          />
        </MobileView>
      </Box>
    </Paper>
  )
}
